export const types = {
  FETCH_CUSTOM_DATA: "[CustomData] Fetch Custom Data",
  FETCH_CUSTOM_DATA_SUCCESS: "[CustomData] Fetch Custom Data success",
  FETCH_CUSTOM_DATA_FAILED: "[CustomData] Fetch Custom Data failed",
  CLEAR_CUSTOM_DATA: "[CustomData] Clear Custom Data",
  FETCH_A_CUSTOM_DATA: "[CustomData] Fetch A Custom Data",
  FETCH_A_CUSTOM_DATA_SUCCESS: "[CustomData] Fetch A Custom Data success",
  FETCH_A_CUSTOM_DATA_FAILED: "[CustomData] Fetch A Custom Data failed",
  FETCH_A_CUSTOM_DATA_LIST: "[CustomData] Fetch A Custom Data List",
  FETCH_A_CUSTOM_DATA_LIST_SUCCESS:
    "[CustomData] Fetch A Custom Data List success",
  FETCH_A_CUSTOM_DATA_LIST_FAILED:
    "[CustomData] Fetch A Custom Data List failed",
  CLEAR_FETCH_A_CUSTOM_DATA_LIST: "[CustomData] Clear Fetch A Custom Data List",
  FETCH_A_CUSTOM_DATA_ALIAS: "[CustomData] Fetch A Custom Data Alias",
  FETCH_A_CUSTOM_DATA_ALIAS_SUCCESS:
    "[CustomData] Fetch A Custom Data Alias success",
  FETCH_A_CUSTOM_DATA_ALIAS_FAILED:
    "[CustomData] Fetch A Custom Data Alias failed",
  DELETE_ALIAS: "[CustomData] Delete A Alias",
  DELETE_ALIAS_SUCCESS: "[CustomData] Delete A Alias success",
  DELETE_ALIAS_FAILED: "[CustomData] Delete A Alias failed",
  CLEAR_CUSTOM_DATA_DETAILS: "[CustomData] Clear Custom Data Details",
  CLEAR_CUSTOM_DATA_DETAILS_LOADING:
    "[CustomData] Clear Custom Data Details Loading",
  REMOVE_MAPPED_KEY: "[CustomData] Remove Mapped Key",
  REMOVE_MAPPED_KEY_SUCCESS: "[CustomData] Remove Mapped Key success",
  REMOVE_MAPPED_KEY_FAILED: "[CustomData] Remove Mapped Key failed",
  FETCH_CUSTOM_DATA_ALIAS_UNMAP: "[CustomData] Fetch Custom Data Alias Unmap",
  FETCH_CUSTOM_DATA_ALIAS_UNMAP_SUCCESS:
    "[CustomData] Fetch Custom Data Alias Unmap success",
  FETCH_CUSTOM_DATA_ALIAS_UNMAP_FAILED:
    "[CustomData] Fetch Custom Data Alias Unmap failed",
  MAP_TO_ALIAS: "[CustomData] Map To Alias",
  MAP_TO_ALIAS_SUCCESS: "[CustomData] Map To Alias success",
  MAP_TO_ALIAS_FAILED: "[CustomData] Map To Alias failed",
  CREATE_ALIAS: "[CustomData] Create Alias",
  CREATE_ALIAS_SUCCESS: "[CustomData] Create Alias Success",
  CREATE_ALIAS_FAILED: "[CustomData] Create Alias Failed",
  UPDATE_ALIAS: "[CustomData] Update Alias",
  UPDATE_ALIAS_SUCCESS: "[CustomData] Update Alias Success",
  UPDATE_ALIAS_FAILED: "[CustomData] Update Alias Failed",
  FETCH_A_ALIAS_LOGS: "[CustomData] Fetch a Alias Logs",
  FETCH_A_ALIAS_LOGS_SUCCESS: "[CustomData] Fetch a Alias Logs Success",
  FETCH_A_ALIAS_LOGS_FAILED: "[CustomData] Fetch a Alias Logs failed",
  FETCH_CUSTOM_DATA_EVENT_LIST: "[CustomData] Fetch Custom Event List Data",
  FETCH_CUSTOM_DATA_EVENT_LIST_SUCCESS:
    "[CustomData] Fetch Custom Event List Data success",
  FETCH_CUSTOM_DATA_EVENT_LIST_FAILED:
    "[CustomData] Fetch Custom Event List Data failed",
  CLEAR_CUSTOM_EVENT_LIST: "[CustomData] Clear Custom Event List Data",

  FETCH_CUSTOM_DATA_LIST: "[CustomData] Fetch Custom Data List",
  FETCH_CUSTOM_DATA_LIST_SUCCESS: "[CustomData] Fetch Custom Data List success",
  FETCH_CUSTOM_DATA_LIST_FAILED: "[CustomData] Fetch Custom Data List failed",
  CLEAR_CUSTOM_DATA_LIST: "[CustomData] Clear Custom Data List",

  LOAD_MORE_CUSTOM_DATA_LIST: "[CustomData] Load More Custom Data List",
  LOAD_MORE_CUSTOM_DATA_LIST_SUCCESS:
    "[CustomData] Load More Custom Data List success",
  LOAD_MORE_CUSTOM_DATA_LIST_FAILED:
    "[CustomData] Load More Custom Data List failed",

  CLEAR_ERROR_RESPONSE: "[CustomData] Clear Error Response",
  FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT:
    "[CustomData] Fetch A Custom Data Alias check count ",
  FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_SUCCESS:
    "[CustomData] Fetch A Custom Data Alias check count success",
  FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_FAILED:
    "[CustomData] Fetch A Custom Data Alias check count failed",
};

export const FetchCustomData = (queryValue, filters) => ({
  type: types.FETCH_CUSTOM_DATA,
  payload: {
    queryValue,
    filters,
  },
});
export const FetchCustomDataSuccess = (list) => ({
  type: types.FETCH_CUSTOM_DATA_SUCCESS,
  payload: list,
});
export const FetchCustomDataFailed = (error) => ({
  type: types.FETCH_CUSTOM_DATA_FAILED,
  payload: error,
});
export const ClearCustomData = () => ({
  type: types.CLEAR_CUSTOM_DATA,
});
export const FetchCustomDataAliasUnmap = (filters, queryValue) => ({
  type: types.FETCH_CUSTOM_DATA_ALIAS_UNMAP,
  payload: {
    filters,
    queryValue,
  },
});
export const FetchCustomDataAliasUnmapSuccess = (response) => ({
  type: types.FETCH_CUSTOM_DATA_ALIAS_UNMAP_SUCCESS,
  payload: response,
});
export const FetchCustomDataAliasUnmapFailed = (error) => ({
  type: types.FETCH_CUSTOM_DATA_ALIAS_UNMAP_FAILED,
  payload: error,
});
export const FetchACustomData = (data) => ({
  type: types.FETCH_A_CUSTOM_DATA,
  payload: data,
});
export const FetchACustomDataSuccess = (data) => ({
  type: types.FETCH_A_CUSTOM_DATA_SUCCESS,
  payload: data,
});
export const FetchACustomDataFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_DATA_FAILED,
  payload: error,
});
export const FetchACustomDataList = (data) => ({
  type: types.FETCH_A_CUSTOM_DATA_LIST,
  payload: data,
});
export const FetchACustomDataListSuccess = (data) => ({
  type: types.FETCH_A_CUSTOM_DATA_LIST_SUCCESS,
  payload: data,
});
export const FetchACustomDataListFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_DATA_LIST_FAILED,
  payload: error,
});
export const ClearFetchACustomDataList = () => ({
  type: types.CLEAR_FETCH_A_CUSTOM_DATA_LIST,
});

export const FetchACustomDataAlias = (key) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS,
  payload: key,
});
export const FetchACustomDataAliasSuccess = (response) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS_SUCCESS,
  payload: response,
});
export const FetchACustomDataAliasFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS_FAILED,
  payload: error,
});
// /////////Delete Alias//////////
export const DeleteAlias = (data) => ({
  type: types.DELETE_ALIAS,
  payload: data,
});
export const DeleteAliasSuccess = (response) => ({
  type: types.DELETE_ALIAS_SUCCESS,
  payload: response,
});
export const DeleteAliasFailed = (error) => ({
  type: types.DELETE_ALIAS_FAILED,
  payload: error,
});
export const ClearCustomDataDetails = () => ({
  type: types.CLEAR_CUSTOM_DATA_DETAILS,
});
export const ClearCustomDataDetailsLoading = () => ({
  type: types.CLEAR_CUSTOM_DATA_DETAILS_LOADING,
});
// /////////Remove Mapped keys//////////
export const RemoveMappedKey = (data) => ({
  type: types.REMOVE_MAPPED_KEY,
  payload: data,
});
export const RemoveMappedKeySuccess = (response) => ({
  type: types.REMOVE_MAPPED_KEY_SUCCESS,
  payload: response,
});
export const RemoveMappedKeyFailed = (error) => ({
  type: types.REMOVE_MAPPED_KEY_FAILED,
  payload: error,
});
export const MapToAlias = (data, isUpdate) => ({
  type: types.MAP_TO_ALIAS,
  payload: {
    data,
    isUpdate,
  },
});
export const MapToAliasSuccess = (response) => ({
  type: types.MAP_TO_ALIAS_SUCCESS,
  payload: response,
});
export const MapToAliasFailed = (error) => ({
  type: types.MAP_TO_ALIAS_FAILED,
  payload: error,
});
export const CreateAlias = (data) => ({
  type: types.CREATE_ALIAS,
  payload: data,
});
export const CreateAliasSuccess = (response) => ({
  type: types.CREATE_ALIAS_SUCCESS,
  payload: response,
});
export const CreateAliasFailed = (error) => ({
  type: types.CREATE_ALIAS_FAILED,
  payload: error,
});
export const UpdateAlias = (data) => ({
  type: types.UPDATE_ALIAS,
  payload: data,
});
export const UpdateAliasSuccess = (response) => ({
  type: types.UPDATE_ALIAS_SUCCESS,
  payload: response,
});
export const UpdateAliasFailed = (error) => ({
  type: types.UPDATE_ALIAS_FAILED,
  payload: error,
});

export const FetchAliasLogs = (collector) => ({
  type: types.FETCH_A_ALIAS_LOGS,
  payload: collector,
});
export const FetchACollectorLogsSuccess = (logs) => ({
  type: types.FETCH_A_ALIAS_LOGS_SUCCESS,
  payload: logs,
});
export const FetchACollectorLogsFailed = (error) => ({
  type: types.FETCH_A_ALIAS_LOGS_FAILED,
  payload: error,
});
export const FetchCustomEventListData = (queryValue, filters) => ({
  type: types.FETCH_CUSTOM_DATA_EVENT_LIST,
  payload: {
    queryValue,
    filters,
  },
});
export const FetchCustomEventListDataSuccess = (list) => ({
  type: types.FETCH_CUSTOM_DATA_EVENT_LIST_SUCCESS,
  payload: list,
});
export const FetchCustomEventListDataFailed = (error) => ({
  type: types.FETCH_CUSTOM_DATA_EVENT_LIST_FAILED,
  payload: error,
});
export const ClearCustomEventListData = () => ({
  type: types.CLEAR_CUSTOM_EVENT_LIST,
});

export const FetchCustomDataList = (queryValue, filters, page) => ({
  type: types.FETCH_CUSTOM_DATA_LIST,
  payload: {
    queryValue,
    filters,
    page,
  },
});
export const FetchCustomDataListSuccess = (list) => ({
  type: types.FETCH_CUSTOM_DATA_LIST_SUCCESS,
  payload: list,
});
export const FetchCustomDataListFailed = (error) => ({
  type: types.FETCH_CUSTOM_DATA_LIST_FAILED,
  payload: error,
});
export const ClearCustomDataList = () => ({
  type: types.CLEAR_CUSTOM_DATA_LIST,
});

export const LoadMoreCustomDataList = (queryValue, filters, page) => ({
  type: types.LOAD_MORE_CUSTOM_DATA_LIST,
  payload: {
    queryValue,
    filters,
    page,
  },
});
export const LoadMoreCustomDataListSuccess = (list) => ({
  type: types.LOAD_MORE_CUSTOM_DATA_LIST_SUCCESS,
  payload: list,
});
export const LoadMoreCustomDataListFailed = (error) => ({
  type: types.LOAD_MORE_CUSTOM_DATA_LIST_FAILED,
  payload: error,
});
export const ClearErrorResponse = () => ({
  type: types.CLEAR_ERROR_RESPONSE,
});
export const FetchACustomDataAliasCheckCount = (data) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT,
  payload: data,
});
export const FetchACustomDataAliasCheckCountSuccess = (response) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_SUCCESS,
  payload: response,
});
export const FetchACustomDataAliasCheckCountFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_DATA_ALIAS_CHECK_COUNT_FAILED,
  payload: error,
});
